module.exports = require("@workbench-stack/language-core");